import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { comics } from '@/mocks/comics';

export default function RankPage() {
  useEffect(() => {
    document.title = '排行榜 - 韩国漫画人气排行 - 韩国漫画网';
  }, []);

  const sorted = [...comics].sort((a, b) => b.views - a.views);

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-20 pb-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-700 font-medium">排行榜</span>
          </nav>
          <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-8">排行榜</h1>
          <div className="space-y-3">
            {sorted.map((comic, i) => (
              <Link key={comic.id} to={`/comic/${comic.id}`} className="flex items-center gap-4 p-4 rounded-xl hover:bg-background-100 transition-colors cursor-pointer group">
                <span className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-heading font-bold ${
                  i < 3 ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-500'
                }`}>{i + 1}</span>
                <div className="w-12 h-16 rounded-lg overflow-hidden flex-shrink-0">
                  <img src={comic.cover} alt={comic.title} className="w-full h-full object-cover object-top" loading="lazy" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-label font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">{comic.title}</h3>
                  <p className="text-xs text-foreground-500">{comic.author} · {comic.categories[0]}</p>
                </div>
                <div className="text-right">
                  <p className="text-sm font-heading font-bold text-accent-600">{comic.rating}</p>
                  <p className="text-xs text-foreground-400">{(comic.views / 10000).toFixed(0)}万阅读</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}